var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/project/senSorSystem","frame-title":"环境监测"}})
}
var staticRenderFns = []

export { render, staticRenderFns }